import Tabs from '../../../components/Tabs/Tabs'
import Asistencias from './tabs/Asistencias/Asistencias'
import Formaciones from './tabs/Formaciones/Formaciones'
import Pruebas from './tabs/Pruebas/Pruebas'
import css from './Profesores.module.css'

const Profesores = () => {
  return (
    <>
      <Tabs
        className={css.tabs}
        tabs={[
          { name: 'Asistencias', content: <Asistencias /> },
          { name: 'Formaciones', content: <Formaciones /> },
          { name: 'Pruebas', content: <Pruebas /> }
        ]}
      />
    </>
  )
}

export default Profesores
